import axios from 'axios'
import router from '@/router';
import store from '@/store'

axios.defaults.withCredentials = false;

// Vue.prototype.$axios = axios;
let instance = axios.create({
  // withCredentials:true,//是否携带凭证
  baseURL: "https://" + window.location.host+"/toppan/safety",//AWS地址
  // baseURL: "http://10.12.58.223:8080/toppan/safety",//223地址
  timeout: 100000,//超时设置
})
// const CancelToken = axios.CancelToken;

// let cancelPendingRequests;

// axios 拦截器
let isRedirectingToLogin = false

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 如果正在跳转到登录页，阻止所有新请求
    if (isRedirectingToLogin) {
      // 抛出一个错误来取消请求，确保 config 不为 undefined
      throw new Error('正在跳转到登录页，请求已取消');
    }
    
    const token = store.getters.getToken

    
    if (token) {
      config.headers.authorization = `Bearer ${token}`
    }
    
    // 显示 loading（排除某些特定请求）
    if (!config.url.includes('/no-loading')) {
      store.dispatch('showLoading')
    }
    
    return config
  },
  error => {
    store.dispatch('hideLoading')
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    store.dispatch('hideLoading')
    return response
  },
  error => {
    store.dispatch('hideLoading')
    const { response } = error
    console.log('response',response);
    
    // 如果是请求拦截器中抛出的取消错误
    if (error.message === '正在跳转到登录页，请求已取消') {
      console.log('请求已被取消');
      return Promise.resolve({
        data: {
          code: 401,
          message: '登录已过期，请求已取消',
          data: null,
          isCanceled: true
        }
      });
    }
    
    if (response?.status === 401) {
      // 如果已经在跳转中，直接返回
      if (isRedirectingToLogin) {
        return Promise.resolve({
          data: {
            code: 401,
            message: '正在跳转到登录页',
            data: null
          }
        });
      }
      
      // 标记开始跳转
      isRedirectingToLogin = true
      
      // 清除token
      store.dispatch('logout')
      
      // 保存当前路由（用于登录后跳转），排除登录相关页面
      const currentRoute = router.currentRoute
      if (currentRoute.path !== '/login' && currentRoute.path !== '/verificationLogin') {
        localStorage.setItem('redirect_path', currentRoute.fullPath)
      }
      
      // 跳转到登录页面
      router.push('/login').then(() => {
        // 跳转完成后重置标记
        isRedirectingToLogin = false
      }).catch(() => {
        isRedirectingToLogin = false
      })
      
      return Promise.resolve({
        data: {
          code: 401,
          data: null,
          isAuthError: true
        }
      });
    }
    
    // 其他错误正常返回
    return Promise.reject(error)
  }
)

export default instance